import { Drawer } from '@mantine/core';
import { CreateProject } from '../../../components/CreateProject';

export const NewAIFMDrawer = ({
  isOpen,
  onClose,
  onSubmit,
  defaultValues,
  isEdit,
  reportType,
  workflowId,
  refetch,
  isAutomation = false
}) => {
  return (
    <Drawer
      opened={isOpen}
      onClose={onClose}
      title={isEdit ? 'Edit period' : 'Add New Period'}
      position="right"
      styles={{
        content: {
          minWidth: 640
        }
      }}
    >
      <CreateProject
        selectedReportType={reportType}
        isUpdate={true}
        defaultValues={defaultValues}
        onClose={onClose}
        refetch={refetch}
        isAutomation={isAutomation}
        workflowId={workflowId}
        submitLabel={isEdit ? 'Update' : 'Create'}
      />
    </Drawer>
  );
};
